'use strict';

import _cloneDeep from "lodash/cloneDeep";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import uniqid from 'uniqid';
import Layout from 'Layouts/Back';
import moment from 'moment';
import Radio from '@material-ui/core/Radio';
import DefaultModal from 'Modals/DefaultModal';
import TextInput from 'Components/Forms/Elements/TextInput';
import DateInput from 'Components/Forms/Elements/DateInput';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import CoworkingPrices from 'Components/Back/CoworkingPrices';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
const price_filter_options = [{
  value: 'one_three',
  label: 'De 1 à 3 heures'
}, {
  value: 'four_seven',
  label: 'De 4 à 7 heures'
}, {
  value: 'height_more',
  label: '8 heures et +'
}];
const price_disposition_filter_options = [{
  value: 'price_day',
  label: 'Prix à la journée'
}, {
  value: 'price_half_day',
  label: 'Prix à la demi-journée'
}];
const date_options = [{
  value: '1',
  label: 'Lundi'
}, {
  value: '2',
  label: 'Mardi'
}, {
  value: '3',
  label: 'Mercredi'
}, {
  value: '4',
  label: 'Jeudi'
}, {
  value: '5',
  label: 'Vendredi'
}, {
  value: '6',
  label: 'Samedi'
}, {
  value: '7',
  label: 'Dimanche'
}];
export default class PriceConfigurationDashboardPage extends Component {
  state = {
    status_messages: {},
    from: moment().format('YYYY-MM-DD'),
    to: moment().add(1, 'days').format('YYYY-MM-DD'),
    etablishment_id: app.state.session.user?.etablishment || app.state.session.user?._etablishment?.id,
    dates: [],
    price_disposition_filter: [],
    price_filter: [],
    date_filter: [],
    openResetFilterModal: false,
    action: 'setPrice'
  };
  reset_filter_ref = React.createRef();
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchSpacesFiltered({
      etablishment_id: app.state.session.user?.etablishment || app.state.session.user?._etablishment?.id
    });
  }
  fetchSpacesFiltered = ({
    etablishment_id,
    spaces_filter,
    type,
    from,
    to
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getSpacesSpaces'), {
      etablishment_id: typeof etablishment_id === 'undefined' ? state.etablishment_id : etablishment_id,
      type: typeof type === 'undefined' ? state.type : type,
      spaces_filter: typeof spaces_filter === 'undefined' ? state.spaces_filter : spaces_filter
    }).then(function (xhr, response) {
      let spaces = (response.data || []).filter(space => space.type !== 'c_open_coworking_space');
      let from_date = from || state.from;
      let to_date = to || state.to;
      const dates = component.computeDatesArray(from_date, to_date);
      component.setState({
        loading: false,
        spaces: spaces,
        spaces_options: state.spaces_options || _cloneDeep(spaces),
        dates: dates
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleFromDateChange = ({
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const str_value = moment(value).format('YYYY-MM-DD');
    const value_plus_one = moment(value).add(1, "days").format('YYYY-MM-DD');
    const dates = component.computeDatesArray(str_value, value_plus_one);
    component.setState({
      [name]: str_value,
      to: value_plus_one,
      dates: dates,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleToDateChange = ({
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (moment(value).isBefore(state.from, 'date')) {
      value = state.from;
    }
    let str_value = moment(value).format('YYYY-MM-DD');
    const dates = component.computeDatesArray(state.from, str_value);
    component.setState({
      [name]: str_value,
      dates: dates,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  computeDatesArray(from, to) {
    let dates = [];
    let end_date = moment(to, 'YYYY-MM-DD');
    let current_date = moment(from, 'YYYY-MM-DD');
    while (current_date.isSameOrBefore(end_date, 'day')) {
      dates.push(current_date.format('YYYY-MM-DD'));
      current_date = current_date.clone().add(1, 'day');
    }
    return dates;
  }
  setNewPrice = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.action === "setPrice" && !state.price_update) {
      component.setState({
        status_messages: {
          price_update: {
            error: "Vous devez renseigner le prix"
          }
        }
      });
      return;
    }
    qwest.post('/coworking-space/set-prices', {
      etablishment_id: state.etablishment_id,
      type: state.type,
      coworking_spaces_filter: state.spaces_filter,
      price_filter: state.price_filter,
      price_disposition_filter: state.price_disposition_filter,
      price_update: state.price_update,
      dates: state.dates,
      date_filter: state.date_filter
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        price_update: undefined
      });
      component.fetchSpacesFiltered({
        etablishment_id: state.etablishment_id
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleFilterTypeChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      spaces_filter: [],
      price_filter: [],
      price_disposition_filter: [],
      price_update: undefined
    });
    component.setState({
      [name]: value
    });
    component.fetchSpacesFiltered({
      type: value,
      spaces_filter: []
    });
  };
  handleActionChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value
    });
  };
  handleSpaceFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["spaces_filter"];
    let spaces = state["spaces_filter"].slice(0);
    if (spaces.includes(name)) {
      spaces = spaces.filter(spaces => spaces !== name);
      component.setState({
        spaces_filter: spaces,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["spaces_filter"];
      spaces.push(name);
      component.setState({
        spaces_filter: spaces,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
    component.fetchSpacesFiltered({
      spaces_filter: spaces
    });
  };
  handlePriceFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["price_filter"];
    let prices = state["price_filter"].slice(0);
    if (prices.includes(name)) {
      prices = prices.filter(prices => prices !== name);
      component.setState({
        price_filter: prices,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["price_filter"];
      prices.push(name);
      component.setState({
        price_filter: prices,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
    component.fetchSpacesFiltered({
      price_filter: prices
    });
  };
  handlePriceDispositionFilterChange = ({
    e,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages['price_disposition_filter'];
    let prices = state['price_disposition_filter'].slice(0);
    if (prices.includes(value)) return;
    component.setState({
      price_disposition_filter: [value],
      info: undefined,
      error: undefined,
      warning: undefined,
      status_messages: status_messages
    });
    component.fetchSpacesFiltered({
      price_disposition_filter: prices
    });
  };
  handleDateFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["date_filter"];
    let dates = state["date_filter"].slice(0);
    if (dates.includes(name)) {
      dates = dates.filter(dates => dates !== name);
      component.setState({
        date_filter: dates,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["date_filter"];
      dates.push(name);
      component.setState({
        date_filter: dates,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
    component.fetchSpacesFiltered({
      date_filter: dates
    });
  };
  resetFilter = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const dates = component.computeDatesArray(moment().format('YYYY-MM-DD'), moment().add(7, 'day').format('YYYY-MM-DD'));
    component.setState({
      type: undefined,
      price_disposition_filter: [],
      price_filter: [],
      date_filter: [],
      spaces_filter: [],
      from: moment().format('YYYY-MM-DD'),
      to: moment().add(7, 'day').format('YYYY-MM-DD'),
      dates: dates
    });
    component.fetchSpacesFiltered({
      etablishment_id: state.etablishment_id,
      from: moment().format('YYYY-MM-DD'),
      to: moment().add(7, 'day').format('YYYY-MM-DD')
    });
    component.closeResetFilterModal();
  };
  openResetFilterModal = ({
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openResetFilterModal: true,
      reset_filter_modal_trigger: e.target
    });
  };
  closeResetFilterModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openResetFilterModal: false,
      reset_filter_modal_trigger: undefined
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    let space_filter = (state.spaces_options || []).filter(space => space.type === state.type).map(function (space) {
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-price__filter",
        key: space.id
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleSpaceFilterChange,
        label: space.name,
        name: space.id,
        value: state['spaces_filter'].includes(space.id),
        status: state.status_messages
      }));
      return output;
    });
    let price_filter = (price_filter_options || []).map(function (price) {
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-price__filter",
        key: price.value
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handlePriceFilterChange,
        label: price.label,
        name: price.value,
        value: state.price_filter.includes(price.value),
        status: state.status_messages
      }));
      return output;
    });
    let price_disposition_filter = (price_disposition_filter_options || []).map(function (price_disposition) {
      const is__checked = state['price_disposition_filter'].includes(price_disposition.value);
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-filters__element-radio",
        key: price_disposition.value
      }, /*#__PURE__*/React.createElement(Radio, {
        onChange: e => component.handlePriceDispositionFilterChange({
          e: e,
          value: price_disposition.value,
          name: 'price_disposition'
        }),
        name: "price_disposition",
        value: price_disposition.value,
        checked: is__checked,
        status: state.status_messages,
        className: "mui-radio",
        color: "primary"
      }), /*#__PURE__*/React.createElement("span", {
        onClick: e => component.handlePriceDispositionFilterChange({
          e: e,
          value: price_disposition.value,
          name: 'price_disposition'
        })
      }, price_disposition.label));
      return output;
    });
    const dates_filter = (date_options || []).map(function (date) {
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-price__filter",
        key: uniqid()
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleDateFilterChange,
        label: date.label,
        name: date.value,
        value: state['date_filter'].includes(date.value),
        status: state.status_messages
      }));
      return output;
    });
    const set_action_area = state.price_filter?.length > 0 || state.price_disposition_filter?.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "u-margin-right-10"
    }, "Actions\xA0: "), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radios u-flex-nowrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state.action === 'resetPrice',
      onChange: component.handleActionChange,
      value: "resetPrice",
      color: "primary",
      name: "action",
      inputProps: {
        'aria-label': 'Rénitialiser le prix'
      },
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'resetPrice',
          name: 'action'
        }
      })
    }, "R\xE9nitialiser le prix")), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state.action === 'setPrice',
      onChange: component.handleActionChange,
      value: "setPrice",
      color: "primary",
      name: "action",
      inputProps: {
        'aria-label': 'Modifier le prix'
      },
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleActionChange({
        target: {
          value: 'setPrice',
          name: 'action'
        }
      })
    }, "Modifier le prix")))) : undefined;
    const can_update_price = [state.from, state.to, ['b_seminar', 'a_calm_coworking_space'].includes(state.type), state.price_disposition_filter?.length || state.price_filter?.length].every(condition => condition);
    const price_update = !can_update_price ? undefined : state.action === 'setPrice' ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['price_update'],
      name: "price_update",
      "safe-value": true,
      type: "text",
      label: "Nouveau prix",
      status: state.status_messages,
      className: "u-margin-right-15"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.setNewPrice
    }, "Mettre \xE0 jour les tarifs"))) : /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.setNewPrice
    }, "R\xE9initialiser les tarifs")));
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Gestion des prix"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--price-dashboard"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: e => component.openResetFilterModal({
        e: e
      })
    }, "R\xE9initialiser les filtres")), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement("strong", null, "D\xE9but de p\xE9riode\xA0:"), /*#__PURE__*/React.createElement(DateInput, {
      onChange: component.handleFromDateChange,
      value: state['from'],
      className: "c-filters__element__date-input",
      name: "from",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--date"
    }, /*#__PURE__*/React.createElement("strong", null, "Fin de p\xE9riode\xA0:"), /*#__PURE__*/React.createElement(DateInput, {
      onChange: component.handleToDateChange,
      value: state['to'],
      className: "c-filters__element__date-input",
      name: "to",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--type c-filters__element--grouped"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "u-margin-right-10"
    }, "Type\xA0:"), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radios u-flex-nowrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['type'] === "a_calm_coworking_space",
      onChange: component.handleFilterTypeChange,
      value: "a_calm_coworking_space",
      color: "primary",
      name: "type",
      inputProps: {
        'aria-label': 'Espace coworking'
      },
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleFilterTypeChange({
        target: {
          name: 'type',
          value: 'a_calm_coworking_space'
        }
      })
    }, "Espace coworking")), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radio"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['type'] === "b_seminar",
      onChange: component.handleFilterTypeChange,
      value: "b_seminar",
      color: "primary",
      name: "type",
      inputProps: {
        'aria-label': 'Séminaire'
      },
      className: "mui-radio"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: e => component.handleFilterTypeChange({
        target: {
          name: 'type',
          value: 'b_seminar'
        }
      })
    }, "S\xE9minaire")))), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element c-filters__element--price-configuration"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Jour(s) \xE0 modifier :"), dates_filter), state.type ? /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Espace(s) :"), space_filter) : undefined, state.type ? /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-container"
    }, /*#__PURE__*/React.createElement("p", {
      className: "c-price__filter-container__title"
    }, "Prix \xE0 modifier\xA0:"), state.type === "a_calm_coworking_space" ? price_filter : /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element-radios"
    }, price_disposition_filter)) : undefined), set_action_area || price_update ? /*#__PURE__*/React.createElement("div", {
      className: "c-price__filter-row-container"
    }, set_action_area, price_update) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(CoworkingPrices, {
      dates: state.dates,
      spaces: state.spaces
    }), /*#__PURE__*/React.createElement("div", {
      className: "u-flex u-full-width u-flex-wrap"
    }, /*#__PURE__*/React.createElement("p", {
      className: bemit('c-legend', ['round', 'open', 'manual'])
    }, "Tarif modifi\xE9"), /*#__PURE__*/React.createElement("p", {
      className: bemit('c-legend', ['round', 'closed', 'manual'])
    }, "Ferm\xE9 manuellement"), /*#__PURE__*/React.createElement("p", {
      className: "c-close-frequently-legend"
    }, "Ferm\xE9 par d\xE9faut")))), status), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.openResetFilterModal,
      title: "R\xE9initialiser les filtres",
      trigger_src: state.reset_filter_modal_trigger,
      "close-ref": component.reset_filter_ref,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeResetFilterModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--blue"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "\xCAtes vous s\xFBr de vouloir r\xE9initialiser les filtres ?")), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-15",
      onClick: component.resetFilter
    }, "R\xE9initialiser"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.reset_filter_ref?.current?.click()
    }, "Annuler"))));
    return output;
  }
}
